import { render } from "./AdminPushBroadcast.vue?vue&type=template&id=398d189a&scoped=true&ts=true"
import script from "./AdminPushBroadcast.vue?vue&type=script&lang=ts"
export * from "./AdminPushBroadcast.vue?vue&type=script&lang=ts"

import "./AdminPushBroadcast.vue?vue&type=style&index=0&id=398d189a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398d189a"]])

export default __exports__